import script from "./manifesto.vue?vue&type=script&setup=true&lang=js"
export * from "./manifesto.vue?vue&type=script&setup=true&lang=js"

import "./manifesto.vue?vue&type=style&index=0&id=7f09f392&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f09f392"]])

export default __exports__